module.exports = __webpack_public_path__ + "static/media/noProduct.9baa6f5c.png";